const CAROUSEL_ITEMS = [
  {
    title: '《我独自升级》完结纪念专题',
    desc: '从E级猎人到暗影君主，回顾这部现象级韩国漫画的完整成长轨迹与经典战役。深度解析主角成肖宇的蜕变之路与作品成功的核心魅力。',
    tag: '完结纪念',
    image: 'https://readdy.ai/api/search-image?query=Epic%20dark%20fantasy%20Korean%20manhwa%20inspired%20scene%20with%20shadowy%20warrior%20silhouette%20against%20dramatic%20purple%20and%20black%20gradient%20background%2C%20mysterious%20atmosphere%2C%20digital%20art%20style%2C%20modern%20webtoon%20aesthetic%2C%20no%20text%2C%20cinematic%20lighting%2C%20clean%20composition&width=800&height=500&seq=carousel-01&orientation=landscape',
  },
  {
    title: '《全知读者视角》动画化决定',
    desc: '全球累计阅读量突破2亿的韩国漫画神作确认动画化！金独子与刘众赫的命运将在荧幕上如何呈现？最新企划情报与制作阵容一览。',
    tag: '动画化',
    image: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20inspired%20fantasy%20scene%20with%20ethereal%20golden%20light%20and%20constellation%20patterns%2C%20mystical%20atmosphere%2C%20warm%20amber%20and%20cream%20tones%2C%20digital%20art%2C%20clean%20modern%20composition%2C%20no%20text%2C%20soft%20gradient&width=800&height=500&seq=carousel-02&orientation=landscape',
  },
  {
    title: '2024年度韩国漫画大赏获奖作品',
    desc: '韩国漫画振兴院最新公布的年度大赏名单，涵盖最佳长篇、最佳新人、最佳作画等多个奖项。看看哪些作品成为了今年的最大赢家。',
    tag: '年度大赏',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20award%20ceremony%20inspired%20Korean%20manhwa%20illustration%20with%20warm%20spotlight%20and%20trophy%20elements%2C%20artistic%20composition%2C%20coral%20and%20gold%20accents%2C%20prestigious%20atmosphere%2C%20digital%20art%2C%20no%20text%2C%20clean%20design&width=800&height=500&seq=carousel-03&orientation=landscape',
  },
  {
    title: '新人漫画家推荐特辑',
    desc: '发掘韩国漫画新生力量！精选五位近期在NAVER和Kakao平台崭露头角的新人漫画家，从画风到叙事都令人眼前一亮，不容错过的潜力股。',
    tag: '新人推荐',
    image: 'https://readdy.ai/api/search-image?query=Fresh%20vibrant%20Korean%20webtoon%20style%20illustration%20with%20young%20artist%20brush%20strokes%20and%20colorful%20palette%2C%20creative%20energy%2C%20warm%20coral%20and%20cream%20tones%2C%20digital%20art%2C%20no%20text%2C%20modern%20aesthetic&width=800&height=500&seq=carousel-04&orientation=landscape',
  },
  {
    title: '奇幻题材漫画精选合集',
    desc: '从剑与魔法到异世界转生，韩国奇幻漫画的想象力令人叹为观止。本合集收录当下最热门的十部奇幻题材韩国漫画，一次看个够。',
    tag: '精选合集',
    image: 'https://readdy.ai/api/search-image?query=Fantasy%20Korean%20manhwa%20inspired%20magical%20scene%20with%20floating%20islands%20and%20ethereal%20light%2C%20warm%20amber%20and%20coral%20gradients%2C%20dreamy%20atmosphere%2C%20digital%20illustration%2C%20no%20text%2C%20clean%20composition&width=800&height=500&seq=carousel-05&orientation=landscape',
  },
];

export default function Carousel() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 text-center mb-3">
          热门专题
        </h2>
        <p className="text-foreground-500 text-sm text-center mb-10">
          精选韩国漫画专题内容，深度解读热门作品与行业动态
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {CAROUSEL_ITEMS.slice(0, 3).map((item) => (
            <div
              key={item.title}
              className="bg-background-50 rounded-xl overflow-hidden cursor-pointer hover:scale-[1.02] transition-transform duration-300"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover"
                />
                <span className="absolute top-3 left-3 px-3 py-1 rounded-full bg-primary-500/90 text-background-50 text-xs font-medium">
                  {item.tag}
                </span>
              </div>
              <div className="p-5">
                <h3 className="font-heading text-base font-bold text-foreground-900 mb-2 line-clamp-1">
                  {item.title}
                </h3>
                <p className="text-foreground-600 text-sm leading-relaxed line-clamp-3">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}

          {CAROUSEL_ITEMS.slice(3, 5).map((item) => (
            <div
              key={item.title}
              className="bg-background-50 rounded-xl overflow-hidden cursor-pointer hover:scale-[1.02] transition-transform duration-300 md:col-span-2 lg:col-span-3"
            >
              <div className="flex flex-col md:flex-row">
                <div className="md:w-2/5 h-48 md:h-auto relative overflow-hidden">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover"
                  />
                  <span className="absolute top-3 left-3 px-3 py-1 rounded-full bg-primary-500/90 text-background-50 text-xs font-medium">
                    {item.tag}
                  </span>
                </div>
                <div className="md:w-3/5 p-6 flex flex-col justify-center">
                  <h3 className="font-heading text-lg font-bold text-foreground-900 mb-2">
                    {item.title}
                  </h3>
                  <p className="text-foreground-600 text-sm leading-relaxed">
                    {item.desc}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}